import _ from 'lodash'
import * as day from '@/utils/day';

/**
 * 将字符全部替换
 * @param {string} string 
 * @param {string | RegExp} pattern 匹配字符
 * @param {string} replacement 替换字符
 */
function replaceAll(pattern, replacement) {
  return function (string) {
    return _.replace(string, new RegExp(pattern, 'g'), replacement);
  }
}

/**
 * 构建 视图-存储 字符转换处理
 * @param {string} viewChar 显示的字符
 * @param {string} storeChar 存储的字符
 */
function replaceCharacter(viewChar, storeChar) {
  return {
    getter: replaceAll(storeChar, viewChar),
    setter: replaceAll(viewChar, storeChar),
  }
}

/**
 * 返回当前日期
 * @returns {string} 2019/01/01
 */
function currentDayStr() {
  return day.date2str(new Date()).replace(/-/g, '/')
}

/**
 * 返回当前时间
 * @returns {string} 08:00
 */
function currentTimeStr() {
  return day.date2timeStr(new Date())
}

export default {
  checkNotEmpty: _.identity,
  getterSetterReplace: replaceCharacter,
  currentDayStr,
  currentTimeStr,
}